import { apiSlice } from "../api/apiSlice";

export const quizzMarksApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getQuizzMarks: builder.query({
			query: () => "/quizMark",
		}),
		addQuizzMark: builder.mutation({
			query: ({ data }) => ({
				url: "/quizMark",
				method: "POST",
				body: data,
			}),
			async onQueryStarted(arg, { queryFulfilled, dispatch }) {
				try {
					const quizz = await queryFulfilled;
					if (quizz?.data?.id) {
						// update tasks cache pessimistically start
						dispatch(
							apiSlice.util.updateQueryData(
								"getQuizzMarks",
								undefined,
								(draft) => {
									draft.push(quizz.data)
								}
							)
						);
						// update tasks cache pessimistically end
					}
				} catch (err) { }
			},
		})
	}),
});

export const {
	useGetQuizzMarksQuery,
	useAddQuizzMarkMutation
} = quizzMarksApi;


